import getEnv from "@/plugins/env";
export default {
  DASHBOARD_REFRESH_INTERVAL: getEnv('DASHBOARD_REFRESH_INTERVAL') || 30,
  DDS_REFRESH_INTERVAL: getEnv('DDS_REFRESH_INTERVAL') || 300,
  DDS_ROOT_ID: getEnv('DDS_ROOT_ID') || '2fda8739-3907-4f05-8c62-dd0876bc4a4a',
  API_URL: getEnv('API_URL') || 'https://emergency.bpms.staging.rusatom.dedyn.io',
  VUE_APP_KC_REALM: getEnv('VUE_APP_KC_REALM') || 'master',
  VUE_APP_KC_AUTH: getEnv('VUE_APP_KC_AUTH') || 'https://keycloak.smartsarov.ru/auth',
  VUE_APP_KC_UI_CLIENT: getEnv('VUE_APP_KC_UI_CLIENT') || 'emergency-ui',
  VUE_APP_KC_ROLE_CLIENT: getEnv('VUE_APP_KC_ROLE_CLIENT') || 'emergency'
};
